<script>
import SpriteSymbol from '../svg/build/sprite.svg'

export default {
  template: '<div class="component-symbols">' + SpriteSymbol + '</div>'
}
</script>

<style>
.component-symbols {
  display: none;
}
</style>


// WEBPACK FOOTER //
// Symbols.vue?2f2ff354